import React, { useEffect, useState } from 'react'
import { useUserContext } from '../../context/userContext'
import moment from 'moment'
import { useFormik } from 'formik'
import { billingFilterValidationSchema, billingInitalValue, billingValidationSchema } from '../../utils/Validation'
import { createOrUpdateBillingApi, getSearchBillingItemApi, removeBillingSeqApi, resetBillingSeqDataApi } from '../../utils/ApiEndpointFunctions'
import toast from 'react-hot-toast'
import BillingFilter from '../modal/BillingFilter'
import Spinwheel from './Spinwheel'

const formatMeasurement = (value) => {
   if (value === undefined || value === null || value === "") return "-"
   const number = Number(value)
   return Number.isFinite(number) ? number.toFixed(2) : "-"
}

const formatQuantity = (value) => {
   if (value === undefined || value === null || value === "") return "-"
   const number = Number(value)
   return Number.isFinite(number) ? number.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"
}

export default function BillingSubSection({index,details,handleAddRow,removeSeqFromList,formik,handleChildSaveData,resetParentData,trackUnsavedChanges}) {
   const { langPreference } = useUserContext()
   const [selectAll, setSelectAll] = useState(false)
   const [addLoader, setAddLoader] = useState(false)
   const [removing, setRemoving] = useState(false)
   const [loading, setLoading] = useState(false);
   const [seqDetails,setSeqDetails] = useState({})
   const [resetDbData,setResetDbData] = useState(false);



   const handleBillingSubmit = async (values) => {
      // console.log("values",values);
      let newItem = values?.items?.filter(ele => ele?.selected && !ele?.saved)
      let removeItem = values?.items?.filter(ele => !ele?.selected && ele?.saved)
      let listItem = values?.items?.filter(ele => ele?.selected)
      if (!newItem?.length && !removeItem?.length && !listItem?.length) {
         toast.error(langPreference?.please_select_items || "Please select items")
         return
      }
      const payload = {
         ...values,
         _id:formik?.values?._id,
         newItem,
         removeItem,
         items: [],
         seqDetails : seqDetails || {},
         serialNo:index+1
      }
      try {
         setAddLoader(true)
         const res = await createOrUpdateBillingApi(payload);
         if (res.status === 200) {
            const { data, message } = res?.data
            toast.success(message);
            const insertItemList = data?.newItem?.map(ele => ele?.qtyItemId)
            const alreadySavedList = billingFormik?.values?.items?.filter(ele => ele?.selected && ele?.saved)?.map(ele => ele?.qtyItemId)
            let updatedList = billingFormik?.values?.items?.map(ele => {
               if (insertItemList?.includes(ele?.qtyItemId) || alreadySavedList?.includes(ele?.qtyItemId)) {
                  return {
                     ...ele,
                     saved: true,
                  }
               } else {
                  return {
                     ...ele,
                     saved: false
                  }
               }
            })

            billingFormik?.setFieldValue("items", updatedList)
            billingFormik?.setFieldValue("billingSeqNoId", data?.billingSeqNoId)
            billingFormik?.setFieldValue("_id", data?._id)
            formik?.setFieldValue("_id", data?._id)
            handleChildSaveData(index,updatedList,data?.billingSeqNoId)
            trackUnsavedChanges(index,false)
         }
      } catch (error) {
         console.log(error);
         
         error && error.response ?
            toast.error(error.response?.data?.message) :
            toast.error("something went wrong");
      }
      setAddLoader(false)
   }


   const billingFormik = useFormik({
      initialValues: billingInitalValue,
      onSubmit: handleBillingSubmit,
    validationSchema: billingValidationSchema(langPreference, formik?.values?.billType)
   })

   const handleFilter = async (values) => {
      try {
         let category = values?.category
         let uniqueBoqItemId = values?.categoryItem?.uniqueBoqItemId
         let boqItemId = values?.boqItemId
         let subCategory = values?.subCategory
         let boqId = values?.boqId
         let vendorId = values?.vendorId
         let uniqueItemId = values?.uniqueItemId
         let date = `${values?.to ? new Date(values?.to).getTime() + "-" : ""}${values?.from ? new Date(values?.from).getTime() : ""}`
         const isClientBilling = formik?.values?.billType === "client"
         let details = {
            category: isClientBilling ? category : "",
            subCategory: isClientBilling ? subCategory : "",
            boqId: isClientBilling ? boqId : "",
            boqItemId: isClientBilling ? boqItemId : "",
            vendorId,
            uniqueItemId,
            date
         }
         setSeqDetails(details)
         setLoading(true)
         const res = await getSearchBillingItemApi(
            uniqueItemId,
            vendorId,
            date,
            uniqueBoqItemId,
            category,
            formik?.values?.billType
         )
         if (res.status === 200) {
            const data = handleAddRow(
               index,
               res?.data?.data,
               billingFormik?.values?.items,
               isClientBilling ? {category, uniqueBoqItemId, boqItemId} : {},
               details
            )
            if (data?.length) {
               toast.success(res?.data?.message || 'Data fetched')
            } else {
               toast.error(langPreference?.no_unbilled_dpr_items || "No unbilled DPR items found for the selected filters")
            }
            billingFormik.setFieldValue("items", [...billingFormik?.values?.items, ...data])
         }
      } catch (error) {
         toast.error(error?.response?.data?.message || "Something went wrong")
         console.log("error", error);
      }
      setLoading(false)
   }

   const filterFormik = useFormik({
      initialValues: {
         Item: "",
         vendorName: "",
         to: "",
         from: "",
         itemId: "",
         category: "",
         subCategory: "",
         boqId: "",
         boqNumber: "",
         uniqueItemId:"",
         categoryItem: "",
         boqItemId:"",
      },
      validationSchema: billingFilterValidationSchema(langPreference, formik?.values?.billType),
      onSubmit: handleFilter
   })

   const checkHandler = (e, ele, index, type) => {
      const checked = e?.target?.checked
      let items = billingFormik.values.items.map((item, i) => {
         if (index === i && !item?.isAllocated) {
            setSelectAll(false)
            return {
               ...item,
               selected: checked,
            }
         } else {
            if (type == "all") {
               setSelectAll(checked)
               return {
                  ...item,
                  selected: item?.isAllocated ? false : checked
               }
            } else {
               return item
            }
         }
      });

      billingFormik.setFieldValue("items", items)
      handleUnSavedChanges(items)
   }
   
   const handleUnSavedChanges = (items)=>{
      trackUnsavedChanges(index,items?.filter(ele => !ele?.selected && ele?.saved)?.length>0)
   }

   useEffect(()=>{
      billingFormik.setFieldValue("billDate",formik?.values?.billDate)
      billingFormik.setFieldValue("raBillNo",formik?.values?.raBillNo)
      billingFormik.setFieldValue("billType",formik?.values?.billType)
   },[formik?.values?.billDate,formik?.values?.raBillNo,formik?.values?.billType])

   useEffect(()=>{
      if(details?.items){
         billingFormik?.setFieldValue("items",details?.items)
      }
      
      if(details?.seqDetails){
         setSeqDetails(details?.seqDetails)
      }


      if(details?.billingSeqNoId){
         billingFormik?.setFieldValue("billingSeqNoId",details?.billingSeqNoId)
      }
   },[details?.billingSeqNoId])


   const handleResetData = async (resetId) => {
      try {
         setResetDbData(true)
         const res = await resetBillingSeqDataApi({ id: resetId })
         if (res.status === 200) {
            resetParentData(index)
            filterFormik?.resetForm()
            billingFormik?.setFieldValue("items",[])
            billingFormik?.setFieldValue("billingSeqNoId", "")
            billingFormik?.setFieldValue("_id","")
         }
      } catch (error) {
         toast.error(error?.response?.data?.message || "Something went wrong")
         console.log("error", error);
      }
      setResetDbData(false)
   }


   const handleResetFilter =()=>{
      if(billingFormik?.values?.items?.filter(ele=>ele?.saved)?.length==0){
         filterFormik?.resetForm()
         resetParentData(index)
         setSeqDetails({})
         billingFormik?.setFieldValue("items",[])
      }
      let resetSeqId = billingFormik?.values?.billingSeqNoId
      if(resetSeqId){
         handleResetData(resetSeqId)
      }
     
   
   }

const handleRemoveSeq = async()=>{
   try {
      setRemoving(true)
      console.log("billingSeqNoId",billingFormik?.values?.billingSeqNoId);
      if(billingFormik?.values?.billingSeqNoId && formik?.values?._id){
         const res = await removeBillingSeqApi({billingSeqNoId:billingFormik?.values?.billingSeqNoId,_id:formik?.values?._id })
         if (res.status === 200) {
            toast.success(res?.data?.message)
         }
      }
      removeSeqFromList(index)
   } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong")
      console.log("error", error);
   }
   setRemoving(false)
}


   return (
      <div>
         <hr />
         <label>{langPreference?.seq_no || "Seq No"} {index+1}</label>
         <BillingFilter index={index} formik={filterFormik} filterDetails={seqDetails} resetDbData={resetDbData} handleResetFilter={handleResetFilter} isDisable={loading || billingFormik?.values?.items?.length} filterType={"billing"} billType={formik?.values?.billType} />
         <div className='billing-items-section' >
            <div className='w-100 mt-1'>
               <div className="billing-items-table-wrap mt-4">
                  <table className="table billing-items-table mb-0" >
                     <thead>
                        <tr>
                           <th>{langPreference?.dpr_date || "DPR Date"}</th>
                           <th>{langPreference?.s_no || "S.No."}</th>
                           <th>{langPreference?.item_description || "Item Description"}</th>
                           <th className="text-center">{langPreference?.no_ || "No"} 1</th>
                           <th className="text-center">{langPreference?.no_ || "No"} 2</th>
                           <th className="text-center" title={langPreference?.length || "Length"}>{langPreference?.length || "L"}</th>
                           <th className="text-center" title={langPreference?.breadth || "Breadth"}>{langPreference?.breadth || "B"}</th>
                           <th className="text-center" title={langPreference?.height || "Height"}>{langPreference?.height || "H"}</th>
                           <th className="text-center" title={langPreference?.diameter || "Diameter"}>{langPreference?.diameter || "D"}</th>
                           <th className="text-end">{langPreference?.qty || "Qty"}</th>
                           <th>{langPreference?.remarks || "Remark"}</th>
                           <th className="billing-items-table__select text-center">
                              {billingFormik?.values?.items?.length > 0 && <input
                                 type="checkbox"
                                 className="form-check-input"
                                 checked={selectAll}
                                 name={`selected`}
                                 onChange={(e) => checkHandler(e, {}, null, "all")}
                              />}

                           </th>
                        </tr>
                     </thead>
                     <tbody>
                        {billingFormik?.values?.items?.map((ele, index) => (
                           <tr
                              key={ele?._id || ele?.qtyItemId || index}
                              className={`${ele?.isAllocated ? "billing-items-table__row--allocated" : ""} ${ele?.selected ? "billing-items-table__row--selected" : ""}`}
                           >
                              <td>
                                 <span className="billing-items-table__date">{ele?.dpr?.createDate ? moment(ele?.dpr?.createDate).format("DD MMM YYYY") : "-"}</span>
                              </td>
                              <td><span className="billing-items-table__serial">{index + 1}</span></td>
                              <td className='billing-items-table__description'>
                                 <div className="billing-items-table__item-path">
                                    {[ele?.dprItem?.commodityPart, ele?.dprItem?.commoditySubPart].filter(Boolean).map((part, partIndex) => (
                                       <span key={`${part}-${partIndex}`}>{part}</span>
                                    ))}
                                 </div>
                                 <div className="billing-items-table__work-description">{ele?.dprItem?.workDescription || "-"}</div>
                              </td>
                              <td className="text-center"><span className="billing-items-table__measure">{formatMeasurement(ele?.number1)}</span></td>
                              <td className="text-center"><span className="billing-items-table__measure">{formatMeasurement(ele?.number2)}</span></td>
                              <td className="text-center"><span className="billing-items-table__measure">{!ele?.isDiameter ? formatMeasurement(ele?.length) : "-"}</span></td>
                              <td className="text-center"><span className="billing-items-table__measure">{!ele?.isDiameter ? formatMeasurement(ele?.breath) : "-"}</span></td>
                              <td className="text-center"><span className="billing-items-table__measure">{formatMeasurement(ele?.height)}</span></td>
                              <td className="text-center"><span className="billing-items-table__measure">{ele?.isDiameter ? formatMeasurement(ele?.diameter) : "-"}</span></td>
                              <td className="text-end"><span className='billing-items-table__quantity'>{formatQuantity(ele?.quantity)}</span></td>
                              <td><span className="billing-items-table__remarks">{ele?.remarks || "-"}</span></td>
                              <td className="billing-items-table__select text-center">
                                 {ele?.isAllocated
                                    ? <span className="billing-items-table__allocated-ra">
                                       RA {ele?.allocatedRABillNo || "-"}
                                    </span>
                                    : <input
                                       type="checkbox"
                                       className="form-check-input"
                                       checked={billingFormik?.values?.items?.[index]?.selected}
                                       name={`items[${index}].selected`}
                                       onChange={(e) => checkHandler(e, ele, index)}
                                    />}
                              </td>

                           </tr>
                        ))}

                     </tbody>
                  </table>
               </div>
            </div>
            <div className='d-flex justify-content-end billing-create-page__actions'>
               <button type="button" disabled={loading || addLoader || removing} className="sbm-purchase" onClick={handleRemoveSeq}>
                  {removing ? <Spinwheel /> : langPreference?.delete || "Delete"}
               </button>
               <button type="button" disabled={loading || addLoader} className="sbm-purchase" onClick={() => {
                  formik?.handleSubmit()
                  let listItem = billingFormik?.values?.items?.filter(ele => ele?.selected)
                  //  console.log("err",Object.keys(formik?.errors)?.length);
                  if (!listItem?.length) {
                     toast.error(langPreference?.please_select_items || "Please select items")
                     return
                  } else if (Object.keys(formik?.errors)?.length) {
                     formik?.handleSubmit()
                  } else {
                     billingFormik?.handleSubmit()
                  }
               }}>
                  {addLoader ? <Spinwheel /> : langPreference?.save || "Save"}
               </button>
            </div>
         </div>

      </div>
   )
}
